import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListComponent, ExcListConfig, ExcSectionGroupComponent, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'app-modal-review-group-ad',
  templateUrl: './modal-review-group-add.component.html',
  styles: []
})
export class ModalReviewGroupAddComponent extends ExcTranslation implements OnInit {

  candidates: any[] = [];
  allAudits: any[] = [];
  listConfigStep1candidates: ExcListConfig = new ExcListConfig();
  listConfigStep1allAudits: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  selectedItemsCandidates: any[] = [];
  selectedItemsallAudits: any[] = [];
  selectedItems: any[] = [];
  step = 1;
  headerAudit: number = null;
  selectionForHeader: any[] = [];
  groupID: string = null;
  @ViewChild('listStep1Candidates') listStep1Candidates: ExcListComponent;
  @ViewChild('listStep1allAudits') listStep1allAudits: ExcListComponent;
  @ViewChild('tabContainer') tabContainer: ExcSectionGroupComponent;

  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private excRest: ExcRestService) {
    super();
    const _self = this;
    _self.listConfigStep1candidates.OnRefresh = (event?) => { _self.loadData(); };
    _self.listConfigStep1candidates.selectionMode =  'multi';
    _self.listConfigStep1candidates.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listConfigStep1candidates.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnPageChanged = (pageNo) => {
      _self.listConfigStep1candidates.paging.pagingPage = pageNo;
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnRefresh = () => {
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedItemsCandidates = [...selectedItems];
    };
    _self.listConfigStep1allAudits.OnRefresh = (event?) => { _self.loadData(); };
    _self.listConfigStep1allAudits.selectionMode =  'multi';
    _self.listConfigStep1allAudits.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listConfigStep1allAudits.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnPageChanged = (pageNo) => {
      _self.listConfigStep1allAudits.paging.pagingPage = pageNo;
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnRefresh = () => {
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedItemsallAudits = [...selectedItems];
    };
  }

  ngOnInit() {
    this.groupID = this.overlayConfig.data.Audits[0]['AuditGroup'];
    this.loadCandidates();
    this.loadAllAudits();
  }
  loadData() {
    this.loadCandidates();
    this.loadAllAudits();
  }

  loadAllAudits() {
    const _self = this;
    const mi = _self.listConfigStep1allAudits.GetMetaInfo();
    const url = _self.excRest.computeUrl('ReviewGroupR_ListAllPossible', {fts: (_self.searchValue !== '' ? _self.searchValue : null)});
    _self.listConfigStep1allAudits.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(cd => {
      _self.allAudits = cd.data;
      _self.listConfigStep1allAudits.paging = cd.paging;
      _self.listConfigStep1allAudits.isLoading = false;
    });
  }
  loadCandidates() {
    const _self = this;
    const mi = _self.listConfigStep1candidates.GetMetaInfo();
    const url = _self.excRest.computeUrl('ReviewGroupR_ListCandidates', {AuditID: _self.overlayConfig.data.Audits[0]['AuditID'], fts: _self.searchValue !== '' ? _self.searchValue : null});
    _self.listConfigStep1candidates.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(cd => {
      if (cd && cd.success === true) {
        _self.candidates = cd.data;
        _self.listConfigStep1candidates.paging = cd.paging;
      }
      _self.listConfigStep1candidates.isLoading = false;
    });
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
  isNextDisabled() {
    if (this.tabContainer) {
      if (this.tabContainer.currentTabIndex === 0 && this.selectedItemsallAudits.length > 0) {
        return false;
      }
      if (this.tabContainer.currentTabIndex === 1 && this.selectedItemsCandidates.length > 0) {
        return false;
      }
    }
    return true;
  }
  nextStep() {
    if (this.tabContainer.currentTabIndex === 0 && this.selectedItemsallAudits.length > 0) {
      this.overlayRef.close({proceed: true, Audits: this.selectedItemsallAudits});

    }
    if (this.tabContainer.currentTabIndex === 1 && this.selectedItemsCandidates.length > 0) {
      this.overlayRef.close({proceed: true, Audits: this.selectedItemsCandidates});

    }
  }
  backStep() {
    this.overlayRef.close({proceed: false});
  }
}
